<template>
  <div>
    <baseFrame
      submitText=""
      clearText=""
      :showCtrls="true"
      :infosArr="infosArr"
      :id="receivableStocktakingPlan.code"
      idText="盘点单号">
      <div slot="content">
        <lk-card title="盘点结果信息">
          <lk-card title="复盘-差异商品" v-if="receivableStocktakingDetailListSY.length">
            <lk-table border :columns="columns" :data="receivableStocktakingDetailListSY" height="300"></lk-table>
          </lk-card>
          <lk-card title="初盘-差异商品" v-if="receivableStocktakingDetailListFY.length">
            <lk-table border :columns="columns1" :data="receivableStocktakingDetailListFY" height="300"></lk-table>
          </lk-card>
          <lk-card title="复盘-无差异商品" v-if="receivableStocktakingDetailListSN.length">
            <lk-table border :columns="columns1" :data="receivableStocktakingDetailListSN" height="300"></lk-table>
          </lk-card>
          <lk-card title="初盘-无差异商品" v-if="receivableStocktakingDetailListFN.length">
            <lk-table border :columns="columns1" :data="receivableStocktakingDetailListFN" height="300"></lk-table>
          </lk-card>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '@/components/frame/BaseFrame.vue';
import inventoryManage from '@/services/inventoryManage';
import utils from '@/libs/utils';

export default {
  name: 'inventoryCheck',
  components: {
    baseFrame,
  },
  data() {
    return {
      receivableStocktakingPlan: {},
      infosArr: [],
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, { row }) => h('lk-table', {
            props: {
              columns: row.diffNum > 0
                ? this.subcolumns2
                : this.subcolumns,
              data: row.diffNum > 0
                ? row.orderDetailList
                : row.depositDetailList,
            },
          }),
        },
        { title: '序号', type: 'index', width: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '通用名', key: 'approvedName', minWidth: 110 },
        { title: '商品名', key: 'goodsName', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '应收数量', key: 'receivablesNum', minWidth: 110 },
        {
          title: '实盘数量', key: 'realCount', minWidth: 130,
        },
        { title: '盘点差异', key: 'diffNum', minWidth: 110 },
        { title: '调整后应收数量', key: 'adjustedNum', minWidth: 120 },
      ],
      subcolumns: [ // 关联收款单column
        { title: '收款单号', key: 'financeDepositCode', width: 110 },
        { title: '核销订单号', key: 'saleOrderCode', width: 110 },
        { title: '门店名称', key: 'storeName', minWidth: 110 },
        {
          title: '收款日期',
          key: 'financeCreateTime',
          minWidth: 110,
          render: (h, { row }) => h('span', row.financeCreateTime
            ? utils.exchangeTime(row.financeCreateTime)
            : ''),
        },
        { title: '收款方式', key: 'proceedsTypeName', minWidth: 110 },
        { title: '收款金额', key: 'proceedsAmount', minWidth: 110 },
        { title: '付款人', key: 'paymentUserName', minWidth: 110 },
        { title: '联系方式', key: 'paymentUserPhone', minWidth: 110 },
        { title: '预收核销金额', key: 'verificationAmount', minWidth: 110 },
        { title: '创建人', key: 'createUserName', minWidth: 110 },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
          render: (h, { row }) => h('span', row.createTime
            ? utils.exchangeTime(row.createTime)
            : ''),
        },
      ],
      subcolumns2: [ // 关联销售明细column
        { title: '销售单号', key: 'saleOrderCode', width: 110 },
        { title: '门店名称', key: 'storeName', minWidth: 110 },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
          render: (h, { row }) => h('span', row.createTime
            ? utils.exchangeTime(row.createTime)
            : ''),
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedName', minWidth: 110 },
        { title: '行号', key: 'lineNum', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批次', key: 'goodsBatchSeq', minWidth: 110 },
        { title: '数量', key: 'verificationCount', minWidth: 110 },
      ],
      tableData: [],
      receivableStocktakingDetailListFN: [], // 初盘无差异商品
      receivableStocktakingDetailListFY: [], // 初盘有差异商品
      receivableStocktakingDetailListSN: [], // 复盘无差异商品
      receivableStocktakingDetailListSY: [], // 复盘有差异商品
    };
  },
  computed: {
    columns1() {
      const { status } = this.receivableStocktakingPlan;
      if ([3, 6].includes(status)) {
        return this.columns.filter(item => item.type !== 'expand');
      }
      return this.columns.filter(item => item.type !== 'expand' && !['receivablesNum', 'diffNum'].includes(item.key));
    },
  },
  methods: {
    getData() {
      inventoryManage.getReceivableCheckInfo({ id: Number.parseInt(this.$route.params.id, 10) })
        .then((res) => {
          if (res.data.status === 200) {
            const result = res.data.data;

            this.receivableStocktakingPlan = result.receivableStocktakingPlan || {};
            this.infosArr = utils.setInfoArr(this.receivableStocktakingPlan);
            this.receivableStocktakingDetailListSY = result.receivableStocktakingDetailListSY || [];
            this.receivableStocktakingDetailListFN = result.receivableStocktakingDetailListFN || [];
            this.receivableStocktakingDetailListFY = result.receivableStocktakingDetailListFY || [];
            this.receivableStocktakingDetailListSN = result.receivableStocktakingDetailListSN || [];
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
